<template>
  <q-modal
    @close="$emit('close')"
  >
    <div class="content">

      <div class="down" :class="{empty: data.video[currentPhoto].thumb !== ''}">

        <svg width="456" height="94" viewBox="0 0 456 94" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M228 17C225.57 17 223.6 14.9107 223.6 12.3333C223.6 9.756 225.57 7.66667 228 7.66667C230.43 7.66667 232.4 9.756 232.4 12.3333C232.4 14.9107 230.43 17 228 17ZM235.221 17.6697C236.832 18.4784 238.084 19.9581 238.658 21.7685L242.851 18.2107C245.732 15.7663 250 17.9418 250 21.8548V40.1453C250 44.0583 245.732 46.2338 242.851 43.7893L238.658 40.2315C237.779 43.0033 235.31 45 232.4 45H212.6C208.955 45 206 41.866 206 38V24C206 21.8605 206.905 19.9451 208.331 18.6611C206.884 16.9978 206 14.7751 206 12.3333C206 7.17868 209.94 3 214.8 3C217.428 3 219.788 4.2221 221.4 6.15975C223.013 4.2221 225.372 3 228 3C232.86 3 236.8 7.17868 236.8 12.3333C236.8 14.3176 236.216 16.1573 235.221 17.6697ZM219.2 12.3333C219.2 14.9107 217.23 17 214.8 17C212.37 17 210.4 14.9107 210.4 12.3333C210.4 9.756 212.37 7.66667 214.8 7.66667C217.23 7.66667 219.2 9.756 219.2 12.3333ZM212.6 21.6667H214.8H228H232.4C233.615 21.6667 234.6 22.7113 234.6 24V38C234.6 39.2887 233.615 40.3333 232.4 40.3333H212.6C211.385 40.3333 210.4 39.2887 210.4 38V24C210.4 22.7113 211.385 21.6667 212.6 21.6667ZM239 27.4542V34.5458L245.6 40.1453V21.8548L239 27.4542Z" fill="#A0A0A0"/>
          <path d="M0.922485 91.6V85.48H1.88249C2.42649 84.952 2.90649 84.256 3.32249 83.392C4.28249 81.504 4.76249 79.12 4.76249 76.24V71.2H15.6825V85.48H17.7225V91.6H15.0825V88H3.56249V91.6H0.922485ZM4.76249 85.48H13.0425V73.72H7.40249V76.24C7.40249 79.024 6.96249 81.408 6.08249 83.392C5.66649 84.272 5.22649 84.968 4.76249 85.48ZM21.2411 86.512C20.0891 85.344 19.5131 83.92 19.5131 82.24C19.5131 80.56 20.0891 79.144 21.2411 77.992C22.4091 76.824 23.8331 76.24 25.5131 76.24C27.1931 76.24 28.6091 76.824 29.7611 77.992C30.9291 79.144 31.5131 80.56 31.5131 82.24C31.5131 83.92 30.9291 85.344 29.7611 86.512C28.6091 87.664 27.1931 88.24 25.5131 88.24C23.8331 88.24 22.4091 87.664 21.2411 86.512ZM22.9451 84.928C23.6331 85.616 24.4891 85.96 25.5131 85.96C26.5371 85.96 27.3931 85.616 28.0811 84.928C28.7691 84.224 29.1131 83.328 29.1131 82.24C29.1131 81.152 28.7691 80.264 28.0811 79.576C27.3931 78.872 26.5371 78.52 25.5131 78.52C24.4891 78.52 23.6331 78.872 22.9451 79.576C22.2571 80.264 21.9131 81.152 21.9131 82.24C21.9131 83.328 22.2571 84.224 22.9451 84.928ZM42.915 84.28L44.595 85.84C44.259 86.272 43.843 86.672 43.347 87.04C42.227 87.84 41.003 88.24 39.675 88.24C37.995 88.24 36.571 87.664 35.403 86.512C34.251 85.344 33.675 83.92 33.675 82.24C33.675 80.56 34.251 79.144 35.403 77.992C36.571 76.824 37.995 76.24 39.675 76.24C41.035 76.24 42.243 76.624 43.299 77.392C43.779 77.744 44.171 78.12 44.475 78.52L42.795 80.08C42.571 79.776 42.307 79.52 42.003 79.312C41.251 78.784 40.475 78.52 39.675 78.52C38.651 78.52 37.795 78.872 37.107 79.576C36.419 80.264 36.075 81.152 36.075 82.24C36.075 83.328 36.419 84.224 37.107 84.928C37.795 85.616 38.651 85.96 39.675 85.96C40.587 85.96 41.379 85.68 42.051 85.12C42.339 84.896 42.627 84.616 42.915 84.28ZM49.8637 88V78.76H45.9037V76.48H56.2237V78.76H52.2637V88H49.8637ZM57.8972 92.68V90.4C57.9612 90.432 58.0972 90.496 58.3052 90.592C58.6092 90.704 58.9532 90.76 59.3372 90.76C60.2812 90.76 60.9612 90.24 61.3772 89.2L61.8572 88L57.1772 76.48H59.8172L63.0572 85L66.2972 76.48H68.9372L63.8972 89.32C62.9212 91.8 61.5212 93.04 59.6972 93.04C59.2012 93.04 58.7692 92.984 58.4012 92.872L57.8972 92.68ZM71.0915 88V76.48H81.5315V88H79.1315V78.76H73.4915V88H71.0915ZM85.1362 88V76.48H87.5362V81.04H93.1762V76.48H95.5762V88H93.1762V83.2H87.5362V88H85.1362ZM100.189 86.512C99.0369 85.344 98.4609 83.92 98.4609 82.24C98.4609 80.56 99.0369 79.144 100.189 77.992C101.357 76.824 102.781 76.24 104.461 76.24C106.141 76.24 107.557 76.824 108.709 77.992C109.877 79.144 110.461 80.56 110.461 82.24C110.461 83.92 109.877 85.344 108.709 86.512C107.557 87.664 106.141 88.24 104.461 88.24C102.781 88.24 101.357 87.664 100.189 86.512ZM101.893 84.928C102.581 85.616 103.437 85.96 104.461 85.96C105.485 85.96 106.341 85.616 107.029 84.928C107.717 84.224 108.061 83.328 108.061 82.24C108.061 81.152 107.717 80.264 107.029 79.576C106.341 78.872 105.485 78.52 104.461 78.52C103.437 78.52 102.581 78.872 101.893 79.576C101.205 80.264 100.861 81.152 100.861 82.24C100.861 83.328 101.205 84.224 101.893 84.928ZM118.622 88V76.48H124.022C125.174 76.48 126.102 76.784 126.806 77.392C127.51 78 127.862 78.736 127.862 79.6C127.862 80.304 127.622 80.896 127.142 81.376C126.934 81.6 126.694 81.768 126.422 81.88C126.774 82.024 127.094 82.216 127.382 82.456C128.022 83.064 128.342 83.792 128.342 84.64C128.342 85.568 127.966 86.36 127.214 87.016C126.462 87.672 125.478 88 124.262 88H118.622ZM121.022 85.84H124.142C124.67 85.84 125.078 85.712 125.366 85.456C125.67 85.184 125.822 84.832 125.822 84.4C125.822 83.968 125.67 83.624 125.366 83.368C125.078 83.096 124.67 82.96 124.142 82.96H121.022V85.84ZM121.022 81.04H123.902C124.862 81.04 125.342 80.64 125.342 79.84C125.342 79.04 124.862 78.64 123.902 78.64H121.022V81.04ZM131.213 88V76.48H133.613V84.16L139.613 76.48H141.773V88H139.373V80.32L133.373 88H131.213ZM143.695 90.88V85.72H144.535C144.871 85.368 145.191 84.896 145.495 84.304C146.135 83.024 146.455 81.536 146.455 79.84V76.48H154.855V85.72H156.535V90.88H154.135V88H146.095V90.88H143.695ZM147.055 85.72H152.455V78.76H148.855V79.84C148.855 81.536 148.551 83.024 147.943 84.304C147.687 84.832 147.391 85.304 147.055 85.72ZM167.688 84.4L169.128 86.08C168.824 86.48 168.424 86.84 167.928 87.16C166.84 87.88 165.6 88.24 164.208 88.24C162.528 88.24 161.104 87.664 159.936 86.512C158.784 85.344 158.208 83.92 158.208 82.24C158.208 80.56 158.776 79.144 159.912 77.992C161.064 76.824 162.456 76.24 164.088 76.24C165.72 76.24 167.064 76.776 168.12 77.848C169.192 78.904 169.728 80.248 169.728 81.88C169.728 82.024 169.704 82.312 169.656 82.744L169.608 83.08H160.728C160.872 83.896 161.272 84.584 161.928 85.144C162.584 85.688 163.384 85.96 164.328 85.96C165.192 85.96 166.008 85.704 166.776 85.192C167.128 84.968 167.432 84.704 167.688 84.4ZM160.728 81.04H167.208C167.016 80.224 166.656 79.584 166.128 79.12C165.6 78.64 164.92 78.4 164.088 78.4C162.392 78.4 161.272 79.28 160.728 81.04ZM173.605 86.512C172.453 85.344 171.877 83.92 171.877 82.24C171.877 80.56 172.453 79.144 173.605 77.992C174.773 76.824 176.197 76.24 177.877 76.24C179.557 76.24 180.973 76.824 182.125 77.992C183.293 79.144 183.877 80.56 183.877 82.24C183.877 83.92 183.293 85.344 182.125 86.512C180.973 87.664 179.557 88.24 177.877 88.24C176.197 88.24 174.773 87.664 173.605 86.512ZM175.309 84.928C175.997 85.616 176.853 85.96 177.877 85.96C178.901 85.96 179.757 85.616 180.445 84.928C181.133 84.224 181.477 83.328 181.477 82.24C181.477 81.152 181.133 80.264 180.445 79.576C179.757 78.872 178.901 78.52 177.877 78.52C176.853 78.52 175.997 78.872 175.309 79.576C174.621 80.264 174.277 81.152 174.277 82.24C174.277 83.328 174.621 84.224 175.309 84.928ZM188.799 87.784C188.495 88.088 188.135 88.24 187.719 88.24C187.303 88.24 186.935 88.088 186.615 87.784C186.311 87.464 186.159 87.096 186.159 86.68C186.159 86.264 186.311 85.904 186.615 85.6C186.935 85.28 187.303 85.12 187.719 85.12C188.135 85.12 188.495 85.28 188.799 85.6C189.119 85.904 189.279 86.264 189.279 86.68C189.279 87.096 189.119 87.464 188.799 87.784ZM198.272 88V71.2H204.992C206.464 71.2 207.672 71.632 208.616 72.496C209.56 73.36 210.032 74.408 210.032 75.64C210.032 76.632 209.688 77.504 209 78.256C208.728 78.56 208.392 78.808 207.992 79C208.536 79.208 209.016 79.512 209.432 79.912C210.392 80.744 210.872 81.8 210.872 83.08C210.872 84.424 210.344 85.584 209.288 86.56C208.248 87.52 206.936 88 205.352 88H198.272ZM200.912 85.72H205.352C206.2 85.72 206.888 85.456 207.416 84.928C207.96 84.4 208.232 83.744 208.232 82.96C208.232 82.176 207.96 81.52 207.416 80.992C206.888 80.464 206.2 80.2 205.352 80.2H200.912V85.72ZM200.912 78.04H204.992C205.712 78.04 206.288 77.832 206.72 77.416C207.168 76.984 207.392 76.432 207.392 75.76C207.392 75.088 207.168 74.544 206.72 74.128C206.288 73.696 205.712 73.48 204.992 73.48H200.912V78.04ZM225.024 88V76.48H227.424V88H225.024ZM216.504 85.84H218.904C219.56 85.84 220.064 85.68 220.416 85.36C220.768 85.04 220.944 84.6 220.944 84.04C220.944 83.48 220.768 83.04 220.416 82.72C220.064 82.4 219.56 82.24 218.904 82.24H216.504V85.84ZM214.104 88V76.48H216.504V80.08H218.904C220.264 80.08 221.344 80.448 222.144 81.184C222.944 81.92 223.344 82.872 223.344 84.04C223.344 85.208 222.944 86.16 222.144 86.896C221.344 87.632 220.264 88 218.904 88H214.104ZM236.311 88V76.48H238.351L242.431 81.52L246.511 76.48H248.551V88H246.151V80.32L242.431 84.88L238.711 80.32V88H236.311ZM253.168 86.512C252.016 85.344 251.44 83.92 251.44 82.24C251.44 80.56 252.016 79.144 253.168 77.992C254.336 76.824 255.76 76.24 257.44 76.24C259.12 76.24 260.536 76.824 261.688 77.992C262.856 79.144 263.44 80.56 263.44 82.24C263.44 83.92 262.856 85.344 261.688 86.512C260.536 87.664 259.12 88.24 257.44 88.24C255.76 88.24 254.336 87.664 253.168 86.512ZM254.872 84.928C255.56 85.616 256.416 85.96 257.44 85.96C258.464 85.96 259.32 85.616 260.008 84.928C260.696 84.224 261.04 83.328 261.04 82.24C261.04 81.152 260.696 80.264 260.008 79.576C259.32 78.872 258.464 78.52 257.44 78.52C256.416 78.52 255.56 78.872 254.872 79.576C254.184 80.264 253.84 81.152 253.84 82.24C253.84 83.328 254.184 84.224 254.872 84.928ZM264.408 88L269.208 81.16L264.768 76.48H267.768L272.088 81.16V76.48H274.488V81.16L278.808 76.48H281.808L277.368 81.16L282.168 88H279.408L275.808 82.84L274.488 84.28V88H272.088V84.28L270.768 82.84L267.168 88H264.408ZM292.619 84.4L294.059 86.08C293.755 86.48 293.355 86.84 292.859 87.16C291.771 87.88 290.531 88.24 289.139 88.24C287.459 88.24 286.035 87.664 284.867 86.512C283.715 85.344 283.139 83.92 283.139 82.24C283.139 80.56 283.707 79.144 284.843 77.992C285.995 76.824 287.387 76.24 289.019 76.24C290.651 76.24 291.995 76.776 293.051 77.848C294.123 78.904 294.659 80.248 294.659 81.88C294.659 82.024 294.635 82.312 294.587 82.744L294.539 83.08H285.659C285.803 83.896 286.203 84.584 286.859 85.144C287.515 85.688 288.315 85.96 289.259 85.96C290.123 85.96 290.939 85.704 291.707 85.192C292.059 84.968 292.363 84.704 292.619 84.4ZM285.659 81.04H292.139C291.947 80.224 291.587 79.584 291.059 79.12C290.531 78.64 289.851 78.4 289.019 78.4C287.323 78.4 286.203 79.28 285.659 81.04ZM300.054 88V78.76H296.094V76.48H306.414V78.76H302.454V88H300.054ZM317.333 84.4L318.773 86.08C318.469 86.48 318.069 86.84 317.573 87.16C316.485 87.88 315.245 88.24 313.853 88.24C312.173 88.24 310.749 87.664 309.581 86.512C308.429 85.344 307.853 83.92 307.853 82.24C307.853 80.56 308.421 79.144 309.557 77.992C310.709 76.824 312.101 76.24 313.733 76.24C315.365 76.24 316.709 76.776 317.765 77.848C318.837 78.904 319.373 80.248 319.373 81.88C319.373 82.024 319.349 82.312 319.301 82.744L319.253 83.08H310.373C310.517 83.896 310.917 84.584 311.573 85.144C312.229 85.688 313.029 85.96 313.973 85.96C314.837 85.96 315.653 85.704 316.421 85.192C316.773 84.968 317.077 84.704 317.333 84.4ZM310.373 81.04H316.853C316.661 80.224 316.301 79.584 315.773 79.12C315.245 78.64 314.565 78.4 313.733 78.4C312.037 78.4 310.917 79.28 310.373 81.04ZM336.282 84.4L337.722 86.08C337.418 86.48 337.018 86.84 336.522 87.16C335.434 87.88 334.194 88.24 332.802 88.24C331.122 88.24 329.698 87.664 328.53 86.512C327.378 85.344 326.802 83.92 326.802 82.24C326.802 80.56 327.37 79.144 328.506 77.992C329.658 76.824 331.05 76.24 332.682 76.24C334.314 76.24 335.658 76.776 336.714 77.848C337.786 78.904 338.322 80.248 338.322 81.88C338.322 82.024 338.298 82.312 338.25 82.744L338.202 83.08H329.322C329.466 83.896 329.866 84.584 330.522 85.144C331.178 85.688 331.978 85.96 332.922 85.96C333.786 85.96 334.602 85.704 335.37 85.192C335.722 84.968 336.026 84.704 336.282 84.4ZM329.322 81.04H335.802C335.61 80.224 335.25 79.584 334.722 79.12C334.194 78.64 333.514 78.4 332.682 78.4C330.986 78.4 329.866 79.28 329.322 81.04ZM341.192 88V76.48H349.352V78.76H343.592V88H341.192ZM352.518 86.512C351.366 85.344 350.79 83.92 350.79 82.24C350.79 80.56 351.366 79.144 352.518 77.992C353.686 76.824 355.11 76.24 356.79 76.24C358.47 76.24 359.886 76.824 361.038 77.992C362.206 79.144 362.79 80.56 362.79 82.24C362.79 83.92 362.206 85.344 361.038 86.512C359.886 87.664 358.47 88.24 356.79 88.24C355.11 88.24 353.686 87.664 352.518 86.512ZM354.222 84.928C354.91 85.616 355.766 85.96 356.79 85.96C357.814 85.96 358.67 85.616 359.358 84.928C360.046 84.224 360.39 83.328 360.39 82.24C360.39 81.152 360.046 80.264 359.358 79.576C358.67 78.872 357.814 78.52 356.79 78.52C355.766 78.52 354.91 78.872 354.222 79.576C353.534 80.264 353.19 81.152 353.19 82.24C353.19 83.328 353.534 84.224 354.222 84.928ZM379.471 84.28L381.151 85.84C380.815 86.272 380.399 86.672 379.903 87.04C378.783 87.84 377.559 88.24 376.231 88.24C374.551 88.24 373.127 87.664 371.959 86.512C370.807 85.344 370.231 83.92 370.231 82.24C370.231 80.56 370.807 79.144 371.959 77.992C373.127 76.824 374.551 76.24 376.231 76.24C377.591 76.24 378.799 76.624 379.855 77.392C380.335 77.744 380.727 78.12 381.031 78.52L379.351 80.08C379.127 79.776 378.863 79.52 378.559 79.312C377.807 78.784 377.031 78.52 376.231 78.52C375.207 78.52 374.351 78.872 373.663 79.576C372.975 80.264 372.631 81.152 372.631 82.24C372.631 83.328 372.975 84.224 373.663 84.928C374.351 85.616 375.207 85.96 376.231 85.96C377.143 85.96 377.935 85.68 378.607 85.12C378.895 84.896 379.183 84.616 379.471 84.28ZM383.66 88V76.48H386.06V81.76L390.98 76.48H393.98L389.54 81.16L394.34 88H391.58L387.98 82.84L386.06 84.88V88H383.66ZM402.737 88V86.32C402.513 86.656 402.209 86.976 401.825 87.28C400.961 87.92 400.025 88.24 399.017 88.24C397.897 88.24 396.977 87.912 396.257 87.256C395.537 86.6 395.177 85.808 395.177 84.88C395.177 83.936 395.473 83.144 396.065 82.504C396.673 81.864 397.497 81.456 398.537 81.28L402.737 80.56C402.737 79.936 402.513 79.424 402.065 79.024C401.617 78.608 401.041 78.4 400.337 78.4C399.633 78.4 398.905 78.664 398.153 79.192C397.881 79.384 397.609 79.64 397.337 79.96L395.777 78.4C396.097 77.984 396.481 77.624 396.929 77.32C397.937 76.6 399.073 76.24 400.337 76.24C401.761 76.24 402.913 76.664 403.793 77.512C404.689 78.344 405.137 79.4 405.137 80.68V88H402.737ZM402.737 82.84V82.48L399.377 83.08C398.177 83.288 397.577 83.808 397.577 84.64C397.577 85.072 397.745 85.44 398.081 85.744C398.433 86.048 398.905 86.2 399.497 86.2C400.409 86.2 401.177 85.88 401.801 85.24C402.425 84.6 402.737 83.8 402.737 82.84ZM415.691 88V83.8C415.403 83.976 415.123 84.12 414.851 84.232C414.163 84.504 413.403 84.64 412.571 84.64C411.291 84.64 410.251 84.208 409.451 83.344C408.651 82.48 408.251 81.312 408.251 79.84V76.48H410.651V79.84C410.651 80.608 410.867 81.224 411.299 81.688C411.747 82.136 412.331 82.36 413.051 82.36C413.771 82.36 414.419 82.224 414.995 81.952C415.283 81.824 415.515 81.68 415.691 81.52V76.48H418.091V88H415.691ZM428.412 88V86.32C428.188 86.656 427.884 86.976 427.5 87.28C426.636 87.92 425.7 88.24 424.692 88.24C423.572 88.24 422.652 87.912 421.932 87.256C421.212 86.6 420.852 85.808 420.852 84.88C420.852 83.936 421.148 83.144 421.74 82.504C422.348 81.864 423.172 81.456 424.212 81.28L428.412 80.56C428.412 79.936 428.188 79.424 427.74 79.024C427.292 78.608 426.716 78.4 426.012 78.4C425.308 78.4 424.58 78.664 423.828 79.192C423.556 79.384 423.284 79.64 423.012 79.96L421.452 78.4C421.772 77.984 422.156 77.624 422.604 77.32C423.612 76.6 424.748 76.24 426.012 76.24C427.436 76.24 428.588 76.664 429.468 77.512C430.364 78.344 430.812 79.4 430.812 80.68V88H428.412ZM428.412 82.84V82.48L425.052 83.08C423.852 83.288 423.252 83.808 423.252 84.64C423.252 85.072 423.42 85.44 423.756 85.744C424.108 86.048 424.58 86.2 425.172 86.2C426.084 86.2 426.852 85.88 427.476 85.24C428.1 84.6 428.412 83.8 428.412 82.84ZM436.927 88V78.76H432.967V76.48H443.287V78.76H439.327V88H436.927ZM448.08 85.84H450.72C451.376 85.84 451.88 85.68 452.232 85.36C452.584 85.04 452.76 84.6 452.76 84.04C452.76 83.48 452.584 83.04 452.232 82.72C451.88 82.4 451.376 82.24 450.72 82.24H448.08V85.84ZM445.68 88V76.48H448.08V80.08H450.72C452.08 80.08 453.16 80.448 453.96 81.184C454.76 81.92 455.16 82.872 455.16 84.04C455.16 85.208 454.76 86.16 453.96 86.896C453.16 87.632 452.08 88 450.72 88H445.68Z" fill="#A0A0A0"/>
        </svg>

        <div @click="getVideoIncident" class="dwnl-btn">Скачать</div>
      </div>


      <div class="content__slide"
        :style="{ backgroundImage: data.video[currentPhoto].thumb ? `url(${assetsEnv}/media/incidents/video/full/${data.video[currentPhoto].thumb})` : '' }"
        :class="{'show': !showSlide, empty: data.video[currentPhoto].thumb !== ''}"
      >


        <div class="content__row">
          <div class="cont">
            <!-- <q-license-plate :number="data.state_number"/> -->
            <span>{{ getDate(data.time_start) }}</span>
          </div>

          <img @click="prevPhoto" class="prev prev-desk" src="@/assets/images/buttonSlid.svg" alt="">

          <img @click="nextPhoto" class="next next-desk" src="@/assets/images/buttonSlid.svg" alt="">
          <img @click="prevPhoto" class="next next-adapt" src="@/assets/images/adapt-arr-act.svg" alt="">
        </div>
      </div>

      <!-- <img class="fake-img" :src="`${assetsEnv}/media/acts/full/${data.photo_in}`" alt=""> -->
    </div>
  </q-modal>
</template>

<script setup>
import { defineProps, ref, computed } from 'vue'
import moment from 'moment'
import store from '@/store'
import useApi from '@/composables/useApi'
import { notify } from '@kyvg/vue3-notification'

const assetsEnv = computed(()=> store.state.isDemoMode ? process.env.VUE_APP_BASE_API_DEMO_ASSETS : process.env.VUE_APP_BASE_API_ASSETS)

const props = defineProps({
  data: {
    type: Object,
    required: true,
  }
})

const currentPhoto = ref(0)

const prevPhoto = () => {
  if(currentPhoto.value === 0){
    currentPhoto.value = props.data.video.length - 1
  } else {
    currentPhoto.value--
  }
}

const nextPhoto = () => {
  if(currentPhoto.value === props.data.video.length - 1){
    currentPhoto.value = 0
  } else {
    currentPhoto.value++
  }
}

const emit = defineEmits(['close'])

const showSlide = ref(false)

const getDate = (time) => {
  return moment(time).utc().format('DD.MM.YYYY ・ HH:mm')
}

const getVideoIncident = async() => {
  store.dispatch('setGlobalPreloader', true)

  const incVid = await useApi('get', `incidents/video?incident_id=${props.data.id}&video_id=${props.data.video[currentPhoto.value].id}`)

  if(incVid.status === "successful"){
    window.open(incVid.data.url, '_self');
    store.dispatch('setGlobalPreloader', false)

  } else {
    notify({ title: "Видео не найдено", type: 'error'})
    store.dispatch('setGlobalPreloader', false)
  }
}
</script>

<style scoped lang="scss">
.content{
  width: 1180px;
  height: 690px;
  position: realative;

  @media (max-width: 1200px){
    width: calc(100vw - 30px);
    height: calc(calc(100vw - 30px) / 1.7);
  }

  .default-image{
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-position: 0 0;
    background-size: cover;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 24px;
  }

  &__slide{
    background-repeat: no-repeat;
    background-size: cover !important;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: inline-block;
    transition: ease .3s;
    z-index: 2;
    opacity: 0;
    border-radius: 22px;
    visibility: hidden;
    &.show{
      opacity: 1;
      visibility: visible;
    }
    &.empty{
      &:before{
        content: "";
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: rgba(#171717, .6);
      }
    }
  }

  &__row{
    padding: 16px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    height: 150px;
    background: linear-gradient(transparent, $gm-dark-gray);
    border-radius: 22px;



    .prev{
      position: absolute;
      left: 10px;
      bottom: 10px;
      cursor: pointer;
    }

    .next{
      position: absolute;
      right: 10px;
      bottom: 10px;
      transform: rotate(180deg);
      cursor: pointer;
    }

    .cont{
      display: flex;
      align-items: center;
      span{
        flex: 1;
        color: $white;
        padding: 0 18px;
        margin-bottom: 4px;
      }
    }

    .prev-adapt,
    .next-adapt{
      display: none;
    }

    @media (max-width: 1330px){
      bottom: auto;
      top: 50%;
      transform: translateY(-50%);
      background: transparent;
      >.cont{
        display: none;
      }
      >.prev{
        bottom: 50px;
        transform: rotate(180deg);

      }
      >.next{
        bottom: 50px;
        transform: rotate(0);
      }
      .prev-desk,
      .next-desk{
        display: none;
      }
      .prev-adapt,
      .next-adapt{
        display: block;
      }
    }
  }
}

.fake-img{
  max-height: 100%;
  opacity: 0;
  visibility: hidden;
}

.down{
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 3;

  &.empty{
    svg{
      path{
        fill: white;
      }
    }
    .dwnl-btn{
      background: white;
      color: #404040;
    }
  }
}

.dwnl-btn{
  margin-top: 32px;
  background: #404040;
  padding: 10px 20px 10px 20px;
  border-radius: 14px;
  color: white;
  width: fit-content;
  cursor: pointer;
}
</style>
